import type React from 'react';
import type { OperationVariables } from '@apollo/react-common';
import { type GraphQLTaggedNode } from 'relay-runtime';

import {
	useQueryInterop,
	type UseQueryInteropSupportedResult,
	type UseQueryInteropSupportedArgs,
} from './useQueryInterop.ts';

export type QueryInteropProps<
	TData,
	TVariables extends Record<string, any> = OperationVariables,
> = {
	query: GraphQLTaggedNode;
	children: (result: UseQueryInteropSupportedResult<TData, TVariables>) => React.JSX.Element | null;
} & UseQueryInteropSupportedArgs<TData, TVariables>[1];

export type QueryInteropResultType<
	TData,
	TVariables extends Record<string, any> = OperationVariables,
> = UseQueryInteropSupportedResult<TData, TVariables>;

export function QueryInterop<
	TData = any,
	TVariables extends Record<string, any> = OperationVariables,
>({ children, query, ...props }: QueryInteropProps<TData, TVariables>): React.JSX.Element | null {
	const result = useQueryInterop<TData, TVariables>(query, props);
	return children(result);
}
